import A11yDialog from 'a11y-dialog';
import { toggleDialogState } from '../../../js/utils';

export default class GlobalMessage {
  init() {
    const globalMessageSelector = '.js-swa-dialog-global-message';
    const globalMessageElement = document.querySelector(globalMessageSelector);
    const styleOverlay = { open: 'swa-dialog-open'};
    const bodyElement = document.querySelector('body');

    if (!globalMessageElement) {
      return;
    }

    window.globalMessageDialog = new A11yDialog(globalMessageElement);
    let scrollY;

    globalMessageDialog.on('show', () => {
      scrollY = window.scrollY;
      toggleDialogState(globalMessageSelector, true);
      globalMessageElement.classList.toggle(styleOverlay.open);
      bodyElement.classList.add('swa-no-scroll');
      bodyElement.style.top='-' + scrollY + 'px';
      bodyElement.classList.add('swa-no-scroll-with-scrollbar');
    });

    globalMessageDialog.on('hide', () => {
      toggleDialogState(globalMessageSelector, false);
      globalMessageElement.classList.toggle(styleOverlay.open);
      bodyElement.classList.remove('swa-no-scroll');
      bodyElement.style.top='';
      bodyElement.classList.remove('swa-no-scroll-with-scrollbar');
      window.scrollTo(0, scrollY);
    });
  }
}
